import React from 'react';
import Lottie from 'lottie-react';

import Column from 'components/common/Column';
import Text from 'components/common/Text';
import lottie from 'assets/lotties/editor_image_lottie.json';

const ImageUploadLoading = () => {
  return (
    <Column
      gap="16px"
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 'auto',
        padding: '16px',
        background: '#000',
        opacity: 0.8,
        borderRadius: '12px',
        zIndex: 50,
      }}
    >
      <Lottie
        animationData={lottie}
        style={{ width: '76px', height: '76px' }}
      />
      <Text color="#fff" size="16px" weight={600}>
        사진 업로드 중이에요
      </Text>
    </Column>
  );
};

export default ImageUploadLoading;
